module.exports = __webpack_public_path__ + "assets/compartilhar.6e3a9866.svg";